import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {DripSequenceListItem} from 'shells/drip-sequence-list-item/drip-sequence-list-item';

import type {SmsDripSequenceFragment as DripSequence} from 'nutshell-graphql-types';

import {useGetSmsDripSequenceEditions} from './graphql/hooks';

type Props = {
    dripSequence: DripSequence;
    isArchived: boolean;
    onDeleteDripSequence: (dripSequenceId: string) => Promise<any>;
    onDuplicateDripSequence?: (dripSequenceId: string) => any;
    onRestoreDripSequence: (dripSequenceId: string) => Promise<any>;
};

export function DripSequenceListItemWrapper(props: Props) {
    const {editions: dripEditions, isLoading: isLoadingEditions} = useGetSmsDripSequenceEditions({
        dripSequenceId: props.dripSequence.id,
        limit: 12,
    });

    return (
        <DripSequenceListItem
            dripSequence={{
                id: props.dripSequence.id,
                name: props.dripSequence.name,
                htmlUrlPath: props.dripSequence.htmlUrlPath,
                editions: props.dripSequence.editions,
                status: props.dripSequence.status,
                startTrigger: props.dripSequence.startTrigger
                    ? {
                          humanReadableTitle: props.dripSequence.startTrigger.humanReadableTitle,
                          humanReadableSubtitle:
                              props.dripSequence.startTrigger.humanReadableSubtitle,
                          id: props.dripSequence.startTrigger.id,
                      }
                    : undefined,
                createdTime: props.dripSequence.createdTime,
                lastStatusChangeTime: props.dripSequence.modifiedTime,
                totalRecipientCount:
                    props.dripSequence.engagementStats.dripProgressionTotalRecipients || 0,
                isRemovable: props.dripSequence.isRemovable,
            }}
            editions={dripEditions.map((edition) => {
                return {
                    id: edition.id,
                    htmlUrlPath: edition.htmlUrlPath,
                    name: edition.name,
                    secondaryInfo: edition.content ? (
                        edition.content
                    ) : (
                        <div style={{fontStyle: 'italic'}}>No message</div>
                    ),
                    status: edition.status,
                    backgroundColor: colors.white,
                };
            })}
            isArchived={props.isArchived}
            isLoading={isLoadingEditions}
            onDeleteDripSequence={props.onDeleteDripSequence}
            onRestoreDripSequence={props.onRestoreDripSequence}
            onDuplicateDripSequence={props.onDuplicateDripSequence}
        />
    );
}
